import React, { useContext } from 'react';
import { GlobalContext } from 'providers/GlobalProvider';

import ContentLayout from 'components/Common/ContentLayout';
import ServiceAccountForm from 'components/TeamManagement/ServiceAccountForm';

const ServiceAccountCreate = () => {
  const { cur_user } = useContext(GlobalContext);

  return (
    <ContentLayout title='Request Service Account for API Access'>
      <ServiceAccountForm admin={cur_user} />
    </ContentLayout>
  );
};

export default ServiceAccountCreate;
